import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { LoadingSpinnerComponent } from '../../loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-forgot-password-form',
  standalone: true,
  imports: [ReactiveFormsModule, LoadingSpinnerComponent],
  templateUrl: './forgot-password-form.component.html',
  styleUrl: '../form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordFormComponent {
  form = input.required<FormGroup>();
  error = input<string>(null);
  loading = input<boolean>(false);
  showInstructions = input<boolean>(false);

  signIn = output();

  showSignIn() {
    this.signIn.emit();
  }
}
